import { render, staticRenderFns } from "./BICOnusDetails.vue?vue&type=template&id=8b858d3a&scoped=true&"
import script from "./BICOnusDetails.vue?vue&type=script&lang=js&"
export * from "./BICOnusDetails.vue?vue&type=script&lang=js&"
import style0 from "./BICOnusDetails.vue?vue&type=style&index=0&id=8b858d3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b858d3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b858d3a')) {
      api.createRecord('8b858d3a', component.options)
    } else {
      api.reload('8b858d3a', component.options)
    }
    module.hot.accept("./BICOnusDetails.vue?vue&type=template&id=8b858d3a&scoped=true&", function () {
      api.rerender('8b858d3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/biconus/BICOnusDetails.vue"
export default component.exports